module.exports = __webpack_public_path__ + "img/0Q3A7692_L_BlackMatted.775b9d1a.jpg";